import React, { ReactNode } from 'react';
// import { Provider } from "react-redux";
// import createStore from "./src/state/createStore";
import AuthFirebaseProvider from './src/providers/auth.providers';
import WrapWithApollo from './wrap-with-apollo';
interface WrapWithProviderProps {
	element: ReactNode;
}

const WrapWithProvider: React.FC<WrapWithProviderProps> = ({ element }) => {
	return (
		<AuthFirebaseProvider>
			<WrapWithApollo>{element}</WrapWithApollo>
		</AuthFirebaseProvider>
	);
};

export default WrapWithProvider;

// export default ({ element }) => {
//   // Instantiating store in `wrapRootElement` handler ensures:
//   //  - there is fresh store for each SSR page
//   //  - it will be called only once in browser, when React mounts
//   // const store = createStore();
//   return (
//     // <Provider store={store}>
//     <ApolloProvider client={Apolloclient()}>
//       <AuthFirebaseProvider>
//         <ToastContainer />

//         {element}
//       </AuthFirebaseProvider>
//     </ApolloProvider>
//     // </Provider>
//   );
// };
